import { createAction } from "redux-act";

export const PlaygroundKillAction = createAction("Playground Kill");
export const PlaygroundKillRequestAction = createAction("Playground Kill - Request");
export const PlaygroundKillSuccessAction = createAction("Playground Kill - Success");
export const PlaygroundKillFailedAction = createAction("Playground Kill - Failed");
